module.exports = __webpack_public_path__ + "static/img/makehaibaoBtn.4d21133.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/makehaibaoBtn.png
// module id = b481
// module chunks = 0